// extracted by mini-css-extract-plugin
export default {"root":"styles_root__zuNrm","row":"styles_row__c-yNp","column":"styles_column__Czlhn"};